import styled from "styled-components";

export const ToggleSwitch = styled.div<{ $isOn: boolean }>`
  width: 36px;
  height: 20px;
  border-radius: 10px;
  background-color: ${(props) => (props.$isOn ? "#16a34a" : "#d1d5db")};
  position: relative;
  transition: background-color 0.2s;
  flex-shrink: 0;
  cursor: pointer;

  &::after {
    content: "";
    position: absolute;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: #ffffff;
    top: 2px;
    left: ${(props) => (props.$isOn ? "18px" : "2px")};
    transition: left 0.2s;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  }
`;
